document.addEventListener('DOMContentLoaded', () => {
  const normalize = (value) =>
    value
      .toLowerCase()
      .trim()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');

  function getSelectedFinish(section) {
    // Button / swatch picker
    const fieldsets = section.querySelectorAll(
      'variant-selects fieldset.product-form__input'
    );

    for (const fieldset of fieldsets) {
      const legend = fieldset.querySelector('legend');
      if (!legend) continue;

      const optionName = legend.childNodes[0]?.textContent
        ?.replace(':', '')
        .trim()
        .toLowerCase();

      if (optionName === 'finish') {
        const checked = fieldset.querySelector('input:checked');
        if (checked) return normalize(checked.value);
      }
    }

    // Dropdown picker
    const selects = section.querySelectorAll(
      'variant-selects select[name^="options["]'
    );

    for (const select of selects) {
      const match = select.name.match(/^options\[(.+)\]$/);

      if (match && match[1].trim().toLowerCase() === 'finish') {
        return normalize(select.value);
      }
    }

    return null;
  }

  function mediaFinishTag(element) {
  const finishData = (element.dataset.finish || '').toLowerCase();

  let match = finishData.match(/finish:([a-z0-9-]+)/);
  if (match) return match[1];

  // Fallback for existing image media
  const image = element.querySelector('img');
  if (!image) return null;

  const alt = (image.getAttribute('alt') || '').toLowerCase();
  match = alt.match(/finish:([a-z0-9-]+)/);

  return match ? match[1] : null;
}

  function filterGallery(section) {
    const selectedFinish = getSelectedFinish(section);
    if (!selectedFinish) return;

    const gallery = section.querySelector('media-gallery');
    if (!gallery) return;

    // Main gallery media
    const mediaItems = gallery.querySelectorAll(
      '#Slider-Gallery-' +
        gallery.id.replace('MediaGallery-', '') +
        ' > [data-media-id]'
    );

    mediaItems.forEach((item) => {
      const tag = mediaFinishTag(item);

      // No finish tag = universal media
      item.hidden = tag !== null && tag !== selectedFinish;
    });

    // Thumbnail buttons
    const thumbnails = gallery.querySelectorAll(
      '.thumbnail-list__item[data-target]'
    );

    thumbnails.forEach((item) => {
      const tag = mediaFinishTag(item);

      item.hidden = tag !== null && tag !== selectedFinish;
    });

    // Move gallery to first visible media item
    const firstVisible = [...mediaItems].find((item) => !item.hidden);

    if (firstVisible && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(firstVisible.dataset.mediaId, false);
    }
  }

  function initializeSection(section) {
    if (!section.querySelector('variant-selects')) return;
    if (!section.querySelector('media-gallery')) return;

    filterGallery(section);

    section.addEventListener('change', (event) => {
      if (
        event.target.matches(
          'variant-selects input[type="radio"], variant-selects select'
        )
      ) {
        requestAnimationFrame(() => filterGallery(section));
      }
    });
  }

  document.querySelectorAll('.shopify-section').forEach(initializeSection);

  // Re-initialize when Shopify dynamically reloads a section
  document.addEventListener('shopify:section:load', (event) => {
    initializeSection(event.target);
  });
});